import React, { useContext, useEffect, useState } from 'react';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from 'react-select'
import axios from "axios";
import Swal from 'sweetalert2';
import { decodeData,currentDateAndTime, formatDateWithTime } from '../../Constants/constants';
import * as XLSX from 'xlsx';
import { useLocation } from 'react-router-dom';
import { formatDate } from '../../Components/InputElements';
import PageTitle from '../../Components/PageTitle';


const AttendanceMusterReport = () => {

    const { apiURL, apiHeaderFile, apiHeaderJSON, permissions,setPermissions } = useContext(ConfigContext);
    const locationParam = useLocation();
    const queryParams = new URLSearchParams(locationParam.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
    
    const [rows, setRows] = useState([]);
    const [shiftRows, setShiftRows] = useState([]);
    const [location_shift_id, setLocation_shift_id] = useState("");
    const [loading, setLoading] = useState(false);
    const [monthOptions, setMonthOptions] = useState([]);
    const [department, setDepartment] = useState([]);
    const [location, setLocation] = useState([]);
    
    const [filter, setFilter] = useState({
        month: null,
        location: null,
        department: null,
        location_shift_id: null,
    });
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);

    const getList = async () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetSalaryHeadList`, {
            params: {

            }, headers
        }).then((response) => {

            let data = response.data;
            // console.log(response?.data);
            if (response.data.success === true) {

                setRows(data?.result?.data);

            } else {

            }
        }).catch(function (error) {
            console.log("error", error);
        });
    }

    const getShiftList = () => {    
        const headers = apiHeaderJSON;
        axios
          .get(`${apiURL}Masters/GetShiftList `, { headers })
          .then((response) => {
            var data = response.data;
            if (response.data.success === true) {
                const temp=data.data.map((row) => ({
                    value: row.company_location_shift_id,
                    label: row.company_location_shift_name,
                  }))
              setShiftRows(temp);
            }
          });
      };

    const getMonthFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetCompanyMonthYearList`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getMonthFilterList", data);
                if (data?.success === true) {
                    setMonthOptions(data?.filterArray)


                } else {

                }
            });
    };
    const getDepartmentFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetDepartments`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getDepartmentFilterList", data);
                if (data?.success === true) {
                    let row = data?.departments?.map((val) => {
                        return { value: val?.department_id, label: val?.department_title }
                    })
                    // row?.splice(0, 0, { value: "All", label: "All" });
                    // let allDepartmentRow = data?.departments?.map((val) => {
                    //     return val?.department_id
                    // });
                    // allDepartmentRow = allDepartmentRow?.join(",");
                    setDepartment(row)


                } else {

                }
            });
    };
    const getLocationFilterList = () => {
        const headers = apiHeaderJSON;
        axios.get(`${apiURL}Payrolls/GetLocations`,
            {
                params: {
                    date: currentDateAndTime()
                }
                , headers
            }).then(async (response) => {
                var data = response.data;
                // console.log("getLocationFilterList", data);
                if (data?.success === true) {
                    let row = data?.locations?.map((val) => {
                        return { value: val?.location_id, label: val?.location_title }
                    })
                    setLocation(row);


                } else {

                }
            });
    };
    useEffect(() => {
        getShiftList();
        getMonthFilterList();
        getDepartmentFilterList();
        getLocationFilterList();
    }, []);

    const handleMultiSelect = (fieldName, selectedOptions) => {
        const ids = selectedOptions ? selectedOptions.map(option => option.value) : [];
        // console.log(ids.join(','))
        setFilter(prevFormData => ({
            ...prevFormData,
            [fieldName]: ids.join(',')
        }));
    };
    // console.log("filter",filter);
  
    const handleExcelDownload = async () => {
        const headers = apiHeaderJSON;
    
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
    
        axios.get(`${apiURL}Payrolls/GetMusterReport`, {
            params: {
                month: filter?.month,
                department_id: filter?.department,
                location_id: filter?.location,
                location_shift_id: filter?.location_shift_id,
                date: currentDateAndTime(),
            },
            headers
        })
        .then(async (response) => {
            const { success, excelData, message } = response.data;
    
            if (success === true) {
                // Assuming `excelData` is an array of objects (representing rows of data)
                const filteredData = excelData.slice(0); // Use this if you need to remove specific rows
    
                // Explicitly set the headers based on the object keys (remove the index row)
                const headers = Object.keys(filteredData[0]);
    
                // Convert the filtered data to a worksheet without auto-indexing
                const worksheet = XLSX.utils.json_to_sheet(filteredData, { skipHeader: true });
    
                // Create a new workbook and append the worksheet
                const wb = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(wb, worksheet, 'Attendance Muster Report');
    
                // Format the current date and time
                const date = new Date();
                const dateString = date.toLocaleDateString();
            
                // Save the file with the correct format
                XLSX.writeFile(wb, `Attendance Muster Report (${formatDateWithTime()?.split(" ")[0]}).xlsx`);
    
                Swal.close();
                Swal.fire({
                    title: `<strong>Success</strong>`,
                    text: message,
                    icon: 'success',
                    showConfirmButton: true
                });
            } else {
                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: message,
                    icon: 'error',
                    showConfirmButton: true
                });
            }
        })
        .catch((error) => {
            Swal.close();
            Swal.fire({
                title: `<strong>Failed</strong>`,
                text: error.response ? error.response.message : error.message,
                icon: 'error',
                showConfirmButton: true
            });
        });
    }
    
    
    
    const handleFilter = () => {

    }
    const handleClearAll = () => {
        setFilter({
            month: null,
            location: null,
            department: null,
            location_shift_id: null,
        });
    }

    return (
        <div class="main-content">
            <div class="page-content">
                <div className="container-fluid">
                    <br />
                    <PageTitle title={`Attendance Muster Report`} primary={`Home`} />
                    <div className="card">
                        <div className="card-body">
                            <div style={{ backgroundColor: "#FAFAFA", borderRadius: "5px" }} className="card-header">
                                <div className="row">
                                    <div className='col-md-2'>
                                        <label htmlFor="Location" className="form-label" > Select Month </label>
                                        <Select
                                            options={monthOptions}
                                            value={
                                                filter?.month
                                                    ? monthOptions.find(option => option.value === filter?.month)
                                                    : null
                                            }
                                            onChange={(selectOption) => setFilter({ ...filter, month: selectOption?.value })}
                                            placeholder={`Select Month`} />
                                    </div>

                                    <div className="col-md-3 ">

                                        {/* <label htmlFor="Department" className="form-label" > Department </label> */}
                                        {/* <Select
                                            value={filter?.department ? department.find(option => option.value === filter?.department) : null}
                                            options={department}
                                            onChange={(selectOption) => setFilter({ ...filter, department: selectOption?.value })}
                                            hint={`Select Department`}
                                            isDisabled={!filter?.month}
                                        /> */}
                                        <div>
                                            <label>Department</label>
                                            <Select
                                                onChange={(selectedOptions) => handleMultiSelect("department", selectedOptions)}
                                                placeholder={filter?.month ? "All" : "Select Department"}
                                                isMulti
                                                options={department}
                                                isDisabled={!filter?.month}
                                                value={filter?.department ? filter?.department.split(',').map(id => department.find(option => option.value == id)) : null}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3 ">
                                        <label htmlFor="Location" className="form-label" > Location </label>
                                        {/* <Select
                                            value={filter?.location ? location.find(option => option.value === filter?.location) : null}
                                            options={location}
                                            onChange={(selectOption) => setFilter({ ...filter, location: selectOption?.value })}
                                            hint={`Select Location`}
                                            isDisabled={!filter?.month}
                                        /> */}
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("location", selectedOptions)}
                                            placeholder={filter?.month ? "All" : "Select Location"}
                                            isMulti
                                            options={location}
                                            isDisabled={!filter?.month}
                                            value={filter?.location ? filter?.location.split(',').map(id => location.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                    <div className="col-md-3 ">
                                        <label htmlFor="Location" className="form-label" > Shift </label>
                                        <Select
                                            onChange={(selectedOptions) => handleMultiSelect("location_shift_id", selectedOptions)}
                                            placeholder={!filter?.location_shift_id ? "All" : "Select Shift"}
                                            isMulti
                                            options={shiftRows}
                                            isDisabled={!filter?.month}
                                            value={filter?.location_shift_id ? filter?.location_shift_id.split(',').map(id => shiftRows.find(option => option.value == id)) : null}
                                        />
                                    </div>
                                    {/* <div className='col-md-2' >
                                        <div>
                                            <label>Apply Filter</label>
                                        </div>
                                        <button type="button" onClick={handleFilter}
                                            className={`btn btn-info btn-label waves-effect waves-light ${(!filter?.month && !filter?.department && !filter?.location) ? 'disabled' : ''}`}>
                                            <i className=" ri-filter-3-fill label-icon align-middle fs-16 me-2" />
                                            Filter
                                        </button>
                                    </div> */}
                                    { decodedData?.includes(6) && ( 
                                    <div style={{ width: "15%" }} className='col-md-2'>
                                        <div>
                                            <label>Export Excel</label>
                                        </div>
                                        <button
                                            type="button"
                                            onClick={handleExcelDownload}
                                            disabled={loading}
                                            className={`${(!filter?.month && !filter?.department && !filter?.location) ? 'disabled' : ''} btn noWrap btn-success btn-label waves-effect waves-light noWrap`}>
                                            <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                            {!loading ? "Export Excel" : "Loading..."}
                                        </button>
                                    </div>)}
                                    <div style={{ width: "10%" }} className='col-md-2'>
                                        <div> <label>Clear Filter</label> </div>
                                        <button type="button"
                                            disabled={loading}
                                            className={`btn noWrap btn-secondary btn-label waves-effect waves-light ${(!filter?.month && !filter?.department && !filter?.location) ? 'disabled' : ''}`}
                                            onClick={handleClearAll} >
                                            <i className=" ri-database-2-line  label-icon align-middle fs-16 me-2"></i> Clear</button>
                                    </div>

                                </div>
                                {/* success message */}
                                <div style={{ width: "60%", margin: "auto" }}>
                                    {successMsg ?
                                        <div className=" position-relative alert alert-success mt-3" role="alert">
                                            {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                        </div>
                                        : null
                                    }
                                    {/* error message */}
                                    {errorMsg ?
                                        <div className=" position-relative alert alert-danger mt-3" role="alert">
                                            {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                        </div> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AttendanceMusterReport;
